var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0649 4.33337C9.98981 4.33337 5.06494 9.25824 5.06494 15.3334C5.06494 21.4085 9.98981 26.3334 16.0649 26.3334C22.1401 26.3334 27.0649 21.4085 27.0649 15.3334C27.0649 9.25824 22.1401 4.33337 16.0649 4.33337ZM3.06494 15.3334C3.06494 8.15367 8.88524 2.33337 16.0649 2.33337C23.2446 2.33337 29.0649 8.15367 29.0649 15.3334C29.0649 22.5131 23.2446 28.3334 16.0649 28.3334C8.88524 28.3334 3.06494 22.5131 3.06494 15.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3813 23.274C23.7713 22.883 24.4045 22.8822 24.7955 23.2722L29.4942 27.9587C29.8853 28.3487 29.8861 28.9819 29.4961 29.3729C29.1061 29.7639 28.4729 29.7648 28.0819 29.3747L23.3832 24.6882C22.9921 24.2982 22.9913 23.6651 23.3813 23.274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.56243f4378d832b871cef99a87563ea4.svg";
export { ForwardRef as ReactComponent };